interface withPlagiarismOrExpertCard {
  showExpertCopy: boolean
  showPlagiarismCopy: boolean
}

export const safeParseJson = (
  withPlagiarismOrExpertCard: string,
  showExpertCopy = false,
  showPlagiarismCopy = false
): withPlagiarismOrExpertCard => {
  try {
    const data = JSON.parse(
      withPlagiarismOrExpertCard as string
    ) as withPlagiarismOrExpertCard
    const expertCopy = data?.showExpertCopy ?? showExpertCopy
    const PlagiarismCopy = data?.showPlagiarismCopy ?? showPlagiarismCopy
    return {
      showExpertCopy: expertCopy,
      showPlagiarismCopy: PlagiarismCopy,
    }
  } catch (error) {
    return {
      showExpertCopy,
      showPlagiarismCopy,
    }
  }
}
